module.exports = __webpack_public_path__ + "media/components/insights/safety-checks/icons/red-icon-88acc2be8d8e3d6ebf39094bd687bab8.png";